module.exports = __webpack_public_path__ + "img/Stemness-CRC_CRLM.a346c86a.png";